import i18n from '../i18n/config';
// Constants used throughout the application
export const API_ENDPOINTS = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8010',
  WS_URL: process.env.REACT_APP_WS_URL || 'http://localhost:8010',
};

export const USER_TYPES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
};

export const USER_TYPE_LABELS = {
  [USER_TYPES.ADMIN]: i18n.t('hardcoded.utils_constants.administrator'),
  [USER_TYPES.MANAGER]: i18n.t('hardcoded.utils_constants.manager'),
  [USER_TYPES.USER]: i18n.t('hardcoded.utils_constants.user'),
};

export const VEHICLE_TYPES = [
  'truck',
  i18n.t('hardcoded.utils_constants.trailer'),
  'semi-trailer',
  'bus',
  'van',
  'other',
];

export const ALARM_STATUSES = {
  OK: 'ok',
  WARNING: 'warning',
  CRITICAL: 'critical',
};

export const ALARM_STATUS_LABELS = {
  [ALARM_STATUSES.OK]: i18n.t('hardcoded.utils_constants.normal'),
  [ALARM_STATUSES.WARNING]: i18n.t('hardcoded.utils_constants.warning'),
  [ALARM_STATUSES.CRITICAL]: i18n.t('hardcoded.utils_constants.critical'),
};

export const ALARM_STATUS_COLORS = {
  [ALARM_STATUSES.OK]: 'success',
  [ALARM_STATUSES.WARNING]: 'warning',
  [ALARM_STATUSES.CRITICAL]: 'error',
};

export const VEHICLE_STATUSES = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  WARNING: 'warning',
  CRITICAL: 'critical',
};

export const VEHICLE_STATUS_LABELS = {
  [VEHICLE_STATUSES.ONLINE]: i18n.t('hardcoded.utils_constants.online'),
  [VEHICLE_STATUSES.OFFLINE]: i18n.t('hardcoded.utils_constants.offline'),
  [VEHICLE_STATUSES.WARNING]: i18n.t('hardcoded.utils_constants.warning'),
  [VEHICLE_STATUSES.CRITICAL]: i18n.t('hardcoded.utils_constants.critical'),
};

export const VEHICLE_STATUS_COLORS = {
  [VEHICLE_STATUSES.ONLINE]: 'success',
  [VEHICLE_STATUSES.OFFLINE]: 'default',
  [VEHICLE_STATUSES.WARNING]: 'warning',
  [VEHICLE_STATUSES.CRITICAL]: 'error',
};

export const CURRENCIES = [
  { code: 'MXN', label: i18n.t('hardcoded.utils_constants.mexican_peso_mxn'), symbol: '$' },
  { code: 'USD', label: i18n.t('hardcoded.utils_constants.us_dollar_usd'), symbol: '$' },
  { code: 'EUR', label: 'Euro (EUR)', symbol: '€' },
  { code: 'GBP', label: 'British Pound (GBP)', symbol: '£' },
  { code: 'CAD', label: i18n.t('hardcoded.utils_constants.canadian_dollar_cad'), symbol: '$' },
];

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: i18n.t('createUser.languages.es') },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: i18n.t('hardcoded.utils_constants.italiano') },
  { code: 'pt', label: 'Português' },
];

export const COUNTRIES = [
  { code: 'MX', label: i18n.t('hardcoded.components_common_phoneinput.mexico') },
  { code: 'US', label: i18n.t('hardcoded.components_common_phoneinput.united_states') },
  { code: 'CA', label: i18n.t('hardcoded.utils_constants.canada') },
  { code: 'BR', label: i18n.t('hardcoded.utils_constants.brazil') },
  { code: 'AR', label: i18n.t('hardcoded.utils_constants.argentina') },
  { code: 'CO', label: i18n.t('hardcoded.utils_constants.colombia') },
  { code: 'ES', label: 'Spain' },
  { code: 'FR', label: 'France' },
  { code: 'DE', label: 'Germany' },
  { code: 'IT', label: i18n.t('hardcoded.utils_constants.italy') },
];

export const TIME_RANGES = [
  { value: 1, label: 'Last Hour' },
  { value: 6, label: 'Last 6 Hours' },
  { value: 24, label: 'Last 24 Hours' },
  { value: 168, label: 'Last Week' },
  { value: 720, label: 'Last Month' },
];

export const PAGE_SIZES = [10, 25, 50, 100];

export const DEFAULT_PAGE_SIZE = 25;

export const CHART_COLORS = [
  '#d32f2f', // Arsenal Red
  '#1976d2', // Blue
  '#388e3c', // Green
  '#f57c00', // Orange
  '#7b1fa2', // Purple
  '#00796b', // Teal
  '#c2185b', // Pink
  '#455a64', // Blue Grey
  '#f9a825', // Amber
  '#e65100', // Deep Orange
];

export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const LOCAL_STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  USER: 'user',
  THEME_MODE: 'themeMode',
  SIDEBAR_COLLAPSED: i18n.t('hardcoded.utils_constants.sidebarcollapsed'),
  LANGUAGE: 'language',
};

export const SESSION_STORAGE_KEYS = {
  REDIRECT_URL: 'redirectUrl',
  FORM_DATA: 'formData',
};

export const ROUTE_PATHS = {
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  VEHICLES: '/vehicles',
  VEHICLES_SCHEMATICS: '/vehicles/schematics',
  SENSORS: '/sensors',
  TELEMETRY: '/telemetry',
  ALARMS: '/alarms',
  USERS: '/users',
  AUDIT: '/audit',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  HELP: '/help',
};

export const PERMISSIONS = {
  // User permissions
  VIEW_DASHBOARD: 'view_dashboard',
  VIEW_VEHICLES: 'view_vehicles',
  CREATE_VEHICLE: 'create_vehicle',
  UPDATE_VEHICLE: 'update_vehicle',
  DELETE_VEHICLE: 'delete_vehicle',

  // Sensor permissions
  VIEW_SENSORS: 'view_sensors',
  CREATE_SENSOR: 'create_sensor',
  UPDATE_SENSOR: 'update_sensor',
  DELETE_SENSOR: 'delete_sensor',

  // Telemetry permissions
  VIEW_TELEMETRY: 'view_telemetry',
  EXPORT_TELEMETRY: 'export_telemetry',

  // Alarm permissions
  VIEW_ALARMS: 'view_alarms',
  CREATE_ALARM: 'create_alarm',
  UPDATE_ALARM: 'update_alarm',
  DELETE_ALARM: 'delete_alarm',

  // User management permissions
  VIEW_USERS: 'view_users',
  CREATE_USER: 'create_user',
  UPDATE_USER: 'update_user',
  DELETE_USER: 'delete_user',

  // Audit permissions
  VIEW_AUDIT: 'view_audit',
  EXPORT_AUDIT: 'export_audit',

  // Company permissions
  UPDATE_COMPANY: 'update_company',
  VIEW_COMPANY_STATS: 'view_company_stats',
};

export const USER_PERMISSIONS = {
  [USER_TYPES.ADMIN]: Object.values(PERMISSIONS),
  [USER_TYPES.MANAGER]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_VEHICLES,
    PERMISSIONS.CREATE_VEHICLE,
    PERMISSIONS.UPDATE_VEHICLE,
    PERMISSIONS.DELETE_VEHICLE,
    PERMISSIONS.VIEW_SENSORS,
    PERMISSIONS.CREATE_SENSOR,
    PERMISSIONS.UPDATE_SENSOR,
    PERMISSIONS.DELETE_SENSOR,
    PERMISSIONS.VIEW_TELEMETRY,
    PERMISSIONS.EXPORT_TELEMETRY,
    PERMISSIONS.VIEW_ALARMS,
    PERMISSIONS.CREATE_ALARM,
    PERMISSIONS.UPDATE_ALARM,
    PERMISSIONS.DELETE_ALARM,
    PERMISSIONS.VIEW_USERS,
    PERMISSIONS.CREATE_USER,
    PERMISSIONS.UPDATE_USER,
    PERMISSIONS.DELETE_USER,
    PERMISSIONS.VIEW_AUDIT,
    PERMISSIONS.EXPORT_AUDIT,
    PERMISSIONS.UPDATE_COMPANY,
    PERMISSIONS.VIEW_COMPANY_STATS,
  ],
  [USER_TYPES.USER]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_VEHICLES,
    PERMISSIONS.VIEW_SENSORS,
    PERMISSIONS.VIEW_TELEMETRY,
    PERMISSIONS.VIEW_ALARMS,
  ],
};

export const FILE_UPLOAD = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: {
    IMAGE: ['image/jpeg', 'image/png', 'image/gif'],
    DOCUMENT: ['application/pdf', 'text/csv', 'application/vnd.ms-excel'],
    ARCHIVE: ['application/zip', i18n.t('hardcoded.utils_constants.applicationx-rar-compressed')],
  },
};

export const VALIDATION_RULES = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE: /^[\+]?[\d\s\-\(\)]+$/,
  RFC: /^[A-Z]{3,4}[0-9]{6}[A-Z0-9]{3}$/,
  MAC_ADDRESS: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
  SENSOR_ID: /^[A-Za-z0-9\-_]+$/, // Alphanumeric with hyphens and underscores
  PASSWORD: {
    MIN_LENGTH: 8,
    REQUIRE_UPPERCASE: true,
    REQUIRE_LOWERCASE: true,
    REQUIRE_NUMBERS: true,
    REQUIRE_SPECIAL: true,
  },
};

export const DATE_FORMATS = {
  DISPLAY: 'MMM DD, YYYY',
  DISPLAY_WITH_TIME: 'MMM DD, YYYY HH:mm',
  API: 'YYYY-MM-DD',
  API_WITH_TIME: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
};

export const REFRESH_INTERVALS = {
  DASHBOARD: 30000, // 30 seconds
  TELEMETRY: 5000,  // 5 seconds
  ALARMS: 10000,    // 10 seconds
  VEHICLE_STATUS: 15000, // 15 seconds
};

// Telemetry data types that come from DynamoDB
export const TELEMETRY_TYPES = {
  PSI: 'PSI',
  TEMP: 'TEMP',
  ACC: 'ACC',
  GPS: 'GPS',
};

export const TELEMETRY_TYPE_LABELS = {
  [TELEMETRY_TYPES.PSI]: i18n.t('hardcoded.utils_constants.pressure'),
  [TELEMETRY_TYPES.TEMP]: i18n.t('hardcoded.utils_constants.temperature'),
  [TELEMETRY_TYPES.ACC]: i18n.t('hardcoded.utils_constants.accelerometer'),
  [TELEMETRY_TYPES.GPS]: i18n.t('hardcoded.utils_constants.gps'),
};

export const TELEMETRY_TYPE_COLORS = {
  [TELEMETRY_TYPES.PSI]: 'primary',
  [TELEMETRY_TYPES.TEMP]: 'secondary',
  [TELEMETRY_TYPES.ACC]: 'success',
  [TELEMETRY_TYPES.GPS]: 'info',
};

export default {
  API_ENDPOINTS,
  USER_TYPES,
  USER_TYPE_LABELS,
  VEHICLE_TYPES,
  ALARM_STATUSES,
  ALARM_STATUS_LABELS,
  ALARM_STATUS_COLORS,
  VEHICLE_STATUSES,
  VEHICLE_STATUS_LABELS,
  VEHICLE_STATUS_COLORS,
  CURRENCIES,
  LANGUAGES,
  COUNTRIES,
  TIME_RANGES,
  PAGE_SIZES,
  DEFAULT_PAGE_SIZE,
  CHART_COLORS,
  NOTIFICATION_TYPES,
  LOCAL_STORAGE_KEYS,
  SESSION_STORAGE_KEYS,
  ROUTE_PATHS,
  PERMISSIONS,
  USER_PERMISSIONS,
  FILE_UPLOAD,
  VALIDATION_RULES,
  DATE_FORMATS,
  REFRESH_INTERVALS,
  TELEMETRY_TYPES,
  TELEMETRY_TYPE_LABELS,
  TELEMETRY_TYPE_COLORS,
};